import React, { useState, useContext, useEffect, useRef } from 'react'
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import { Editor } from '@tinymce/tinymce-react';

import { BlogContext } from '../../contexts/BlogContext';
import { OptionsContext } from '../../contexts/OptionsContext';

import formatUrlTitle from '../../helpers/formatUrlTitle'
import { uploadImages } from '../../helpers/uploadImages'

import './CMSForm.css'
window.Buffer = window.Buffer || require("buffer").Buffer;

const CMSForm = ({ closeForm, initialData }) => {
  const { createBlog, editBlog } = useContext(BlogContext)
  const { tags } = useContext(OptionsContext)

  const editorRef = useRef(null);
  const [inputData, setInputData] = useState({
    title: '',
    url_title: '',
    shortDescription: '',
    body: '',
    thumbnail: '',
    tags:[],
    image: '',
    published: false,
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {

      let thumbnail = initialData.thumbnail ? { name: initialData.thumbnail } : {}
      let image = initialData.image ? { name: initialData.image } : {}

      setInputData({
        ...initialData,
        thumbnail,
        image,
        tags: initialData.tags && initialData.tags.length > 0 ? initialData.tags.map(e => {
          const found = tags.find(tag => tag._id === e)
          return found?.name
        }).filter(Boolean) : []
      })
    }
  }, [initialData, tags])


  function handleChange(e) {
    const { name, value } = e.target;

    setInputData({
      ...inputData,
      [name]: value,
      ...name === 'title' && { url_title: formatUrlTitle(value.replace(/[^a-zA-Z ]/g, "")) }
    });

  }

  function handleToggleChange(e) {
    const { name, checked } = e.target;

    setInputData({
      ...inputData,
      [name]: checked,
    });
  }

  function handleCloseForm(e) {
    // mousedown (not click): a failed save unmounts the spinner under the cursor,
    // and the leftover click would otherwise hit this overlay and dismiss the form.
    if (isSubmitting) return
    if (e.target === e.currentTarget) closeForm()
  }

  async function handleClick() {
    const body = editorRef.current?.getContent()
    if (!inputData.title || !inputData.shortDescription || !body || !inputData.image) {
      setError('Please fill out all required fields.')
      return
    }

    setError('')
    setIsSubmitting(true)
    try {
      let thumbnail = inputData?.thumbnail && inputData.thumbnail instanceof File && await uploadImages([{ file: inputData.thumbnail, name: inputData.thumbnail.name }])
      let image = inputData?.image && inputData.image instanceof File && await uploadImages([{ file: inputData.image, name: inputData.image.name }])


      let data = {
        ...inputData,
        body
        , tags: inputData.tags?.length > 0 ? inputData.tags.map(e => {
          const found = tags.find(tag => tag.name === e)
          return found?._id
        }).filter(Boolean) : []
        , thumbnail: thumbnail ? thumbnail[0].url : initialData.thumbnail ? initialData.thumbnail : null
        , image: image ? image[0].url : initialData.image ? initialData.image : null
      }

      if (initialData && Object.keys(initialData).length > 0) {
        await editBlog(initialData._id, data)
      } else {
        await createBlog(data)
      }
      closeForm()
    } catch (error) {
      console.error('Error submitting form:', error)
      const errorData = error.response?.data
      setError(errorData?.errors?.length ? errorData.errors.join(' ') : errorData?.msg || errorData?.message || 'Failed to save blog.')
    } finally {
      setIsSubmitting(false)
    }

  }

  function handleImgChange(e, index) {
    setInputData({
      ...inputData,
      image: e.target.files[0],
    });
  }

  function handleThumbnailChange(e) {
    setInputData({
      ...inputData,
      thumbnail: e.target.files[0],
    });
  }



  return (
    <div onMouseDown={handleCloseForm} className="modal-overlay">
      <div className="manage-facility-form">
        <h3 className="manage-facility-form-title">
          {initialData && Object.keys(initialData).length > 0 ? 'Edit Blog' : 'Create Blog'}
        </h3>

        <label htmlFor="title">Title</label>
        <InputBase className='manger-facility-input' value={inputData.title} onChange={(e) => handleChange(e)} type="text" name="title" id="title" placeholder='Title' />

        <label htmlFor="title">Url Title</label>
        <InputBase className='manger-facility-input' value={inputData.url_title} onChange={(e) => handleChange(e)} type="text" name="url_title" id="url_title" placeholder='Url Title' />


        <label htmlFor="shortDescription">Short Description</label>
        <InputBase className='manger-facility-input' value={inputData.shortDescription} onChange={(e) => handleChange(e)} type="text" name="shortDescription" id="shortDescription" placeholder='Short Description' />

        <label htmlFor="phone">Tags</label>
        <FormControl fullWidth>
            <Select
                multiple
                className="manger-facility-input"
                value={inputData.tags}
                name="tags"
                onChange={(e) => handleChange(e)}
            >
                {tags.length > 0 ? tags.map(e => <MenuItem key={e.name} value={e.name}>{e.name}</MenuItem>) : <MenuItem value={''}>No Tags</MenuItem>}
            </Select>
        </FormControl>

        <label htmlFor="phone">Body</label>
        <Editor
          apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
          initialValue={inputData.body}
          onInit={(evt, editor) => editorRef.current = editor}
          init={{
            height: 500,
            marginBottom: 10,
            menubar: false,
            plugins: [
              'code',
            ],
            toolbar: 'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help | code',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />

        <label htmlFor="phone">Published / Unpublished</label>
        <div style={{ marginBottom: 10 }}>
          <FormControlLabel control={<Switch onChange={(e) => handleToggleChange(e)} value={inputData.published} name="published" />} label={inputData.published.toString()} />
        </div>

        <label className="manage-facility-form-title">Thumbnail</label>
        <div style={{ marginBottom: 10 }}>
          <input onChange={(e) => handleThumbnailChange(e)} accept="image/*" id="contained-button-file" multiple type="file" />
          <p>{inputData.thumbnail?.name}</p>
          {/* {inputData.thumbnail?.name && <div style={{ fontWeight: 600, color: 'blue', cursor: 'pointer' }}>clear</div>} */}
          {inputData.thumbnail?.name &&
            <div
              style={{ fontWeight: 600, color: 'blue', cursor: 'pointer' }}
              onClick={() => {
                setInputData({
                  ...inputData,
                  thumbnail: ''
                })
              }}
            >
              clear
            </div>
          }
        </div>

        <label className="manage-facility-form-title">Main Image</label>
        <div style={{ marginBottom: 10 }}>
          <input onChange={(e) => handleImgChange(e)} accept="image/*" id="contained-button-file" multiple type="file" />
          <p>{inputData.image?.name}</p>
          {inputData.image?.name &&
            <div
              style={{ fontWeight: 600, color: 'blue', cursor: 'pointer' }}
              onClick={() => {
                setInputData({
                  ...inputData,
                  image: ''
                })
              }}
            >
              clear
            </div>
          }
        </div>

        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Button className='manger-facility-btn' disabled={isSubmitting} onClick={() => handleClick()}>{isSubmitting ? 'Submitting...' : 'Submit'}</Button>
        </div>
        {error && <p style={{ textAlign: 'center', color: '#E23844' }}>{error}</p>}
      </div>
    </div>
  )
}

export default CMSForm



